import { FormattedMessage } from 'react-intl';
import { DateRules, eligibleDayCount } from '@/shared/dateInterest';

interface Props {
  rules: DateRules;
  notBefore?: string;
}

export default function DateInterestPreview({ rules, notBefore }: Props) {
  const count = eligibleDayCount(rules, notBefore);

  if (count === 0) {
    return (
      <div role="alert" className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
        <p className="text-sm font-semibold text-amber-800">
          <FormattedMessage id="accounts.configForm.previewNoDays" />
        </p>
        <p className="mt-1 text-xs text-amber-700">
          <FormattedMessage id="accounts.configForm.previewNoDaysHelp" />
        </p>
      </div>
    );
  }

  return (
    <p aria-live="polite" className="text-sm font-semibold text-brand-900">
      <FormattedMessage id="accounts.configForm.previewCount" values={{ count }} />
    </p>
  );
}
